import { render, staticRenderFns } from "./AMSPagination.vue?vue&type=template&id=384cdf07&scoped=true&"
import script from "./AMSPagination.vue?vue&type=script&lang=ts&"
export * from "./AMSPagination.vue?vue&type=script&lang=ts&"
import style0 from "./AMSPagination.vue?vue&type=style&index=0&id=384cdf07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384cdf07",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VPagination } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {VBtn,VList,VListTile,VListTileTitle,VMenu,VPagination,VSpacer,VToolbar})
